import type { AssetId, ChainAddressId } from '@infinex/asset-config';

import type { ChainTokenBalanceListUIProps } from '../ChainTokenBalanceListUI';

export function addIsDisabledAndSort({
  sortedTokenBalanceKeys,
  isAtSelectionLimit,
  selectedKeys,
  tokenBalances,
  checkIsDisabled,
  selectionLimit,
  selectionLimitMessage,
}: Pick<ChainTokenBalanceListUIProps, 'selectedKeys' | 'tokenBalances'> & {
  sortedTokenBalanceKeys: ChainAddressId[];
  checkIsDisabled?: (
    chainAddressId: ChainAddressId,
    assetId?: AssetId
  ) =>
    | {
        disabledLabel?: string;
        disabledDetails?: string;
      }
    | false
    | undefined;

  /** Flag indicating if selection limit has been reached */
  isAtSelectionLimit?: boolean;
  /** Maximum number of items that can be selected in multi-select mode */
  selectionLimit?: number;
  /** Custom message to show when selection limit is reached */
  selectionLimitMessage?: string;
}) {
  return sortedTokenBalanceKeys
    .map((chainAddressId) => {
      if (isAtSelectionLimit && !selectedKeys?.has(chainAddressId)) {
        return {
          chainAddressId,
          isDisabled: {
            disabledLabel: 'Selection limit reached',
            disabledDetails:
              selectionLimitMessage ||
              (selectionLimit
                ? `Maximum ${selectionLimit} assets can be selected`
                : 'Selection limit reached'),
          },
        };
      }

      return {
        chainAddressId,
        isDisabled: checkIsDisabled?.(
          chainAddressId,
          tokenBalances[chainAddressId]?.assetId
        ),
      };
    })
    .sort((a, b) => {
      if (a.isDisabled && !b.isDisabled) return 1;
      if (!a.isDisabled && b.isDisabled) return -1;
      return 0;
    });
}
